<template>
  <div>
    <div
      v-if="serviceList.length > 0"
      class="community-service-container"
    >
      <div
        ref="communityServiceSwiper"
        v-swiper:community-service="swiperOptions"
        class="community-service-swiper"
      >
        <div class="swiper-wrapper">
          <div
            v-for="(service, index) in serviceList"
            :key="index"
            class="swiper-slide community-service-swiper-slide"
          >
            <div class="community-service-swiper__card">
              <div class="community-service__image">
                <a
                  class="community-service__link"
                  @click.stop="goServiceDetail(service.ServiceId, service.Title)"
                >
                  <img
                    :src="service.ImageUrl"
                    :alt="service.Title"
                  >
                </a>
              </div>
              <div class="community-service__content">
                <div
                  v-if="service.HasPromotion"
                  class="community-service__tag-list"
                >
                  <p
                    class="community-service__tag-list__tag eventOrange"
                  >
                    優惠中
                  </p>
                </div>
                <h3 class="community-service__title">
                  {{ service.Title.length > 10 ? service.Title.slice(0, 10) : service.Title }}
                </h3>
              </div>
              <div
                v-if="service.Description"
                class="community-service__footer"
              >
                <p class="community-service__description">
                  {{ service.Description > 16 ? service.Description.slice(0, 16) : service.Description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="community-service__loading"
    >
      <v-skeleton-loader
        v-for="x in 8"
        :key="x"
        class="homepage-loader__card-container__card"
        type="card"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serviceList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false
      },
      activeIndex: 0
    }
  },
  methods: {
    goServiceDetail (serviceId, serviceTitle) {
      this.$gaLogEvent('首頁', `click_${serviceTitle}_${serviceId}`)
      this.$router.push({
        name: 'category-category-service',
        params: { category: -1, service: serviceId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$contentContainerMaxWidth: calc(263px * 4 + 24px * 3);
$contentContainerMaxWidthMargin: calc(263px * 4 + 24px * 3 + 100px);
.community-service {
  &-container {
    padding: 0;
    padding-left: 16px;
    .swiper-slide {
      max-width: 168px;
      padding-right: 8px;
      padding-bottom: 24px;
    }
  }
  &__content {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 160px;
    pointer-events: none;
  }
  &__tag-list {
    display: flex;
    align-items: center;
    position: absolute;
    top: 6px;
    left: 8px;
    &__tag {
      padding: 2px 8px;
      font-weight: bold;
      font-size: pxTorem(15px);
      background: #fd773d;
      border-radius: 2px;
      &.title-tag {
        margin-right: 12px;
        font-size: pxTorem(12px);
      }
      &.eventOrange {
        color: $color-text-inverse;
      }
      &.mainColor {
        color: $color-primary;
        background-color: $color-background-tertiary;
      }
    }
  }
  &__title {
    color: $color-text-inverse;
    font-size: pxTorem(16px);
    text-align: center;
    max-width: 110px;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    @include lineClamp(3);
  }
  &__link {
    display: flex;
  }
  &__image {
    aspect-ratio: 1 / 1;
    width: 100%;
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid $color-border-primary;
    position: relative;
    &::before {
      background-color: rgba(0, 0, 0, 0.3);
      content: '';
      display: flex;
      width: 100%;
      height: 100%;
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__footer {
    padding: 16px 12px;
    background-color: $color-background-secondary;
    border-radius: 8px;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08);
    position: relative;
    z-index: 2;
    margin: 0 8px;
    margin-top: -46px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  &__description {
    font-size: pxTorem(13px);
    color: $color-caption;
    font-weight: bold;
    text-align: center;
    margin: 0;
    @include lineClamp(2);
  }
  &__loading {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    padding: 0 16px;
    ::v-deep {
      .homepage-loader {
        &__card-container__card:nth-child(n) {
          flex-shrink: 0;
          width: 160px;
          margin-right: 8px;
          margin-bottom: 24px;
          .v-skeleton-loader{
            &__image {
              width: 160px;
              height: 160px;
              border-radius: 12px;
            }
            &__card-heading {
              margin: 0 12px;
              margin-top: -46px;
              border-radius: 8px;
              background: #fff;
              z-index: 1;
              box-shadow: 0 0 0 3px #fff;
              .v-skeleton-loader__bone {
                border-radius: 8px;
                height: 68px;
                width: 100%;
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
